export const DEFAULT_CCA_COLUMNS = [
  "createDateTime",
  "resolvedDateTime",
  "status",
  "customer",
  "locationId",
  "caseNo",
  "customerTicketNo",
  "activityType",
  "category",
  "subCategory",
  "locationName",
  "region",
  "assignmentGroup",
  "reportedBy",
  "remarks",
  "resolutionNotes",
];
export const DEFAULT_DISPATCHER_COLUMNS = [
  "customerTicketNo",
  "caseNo",
  "taskNo",
  "locationId",
  "region",
  "locationName",
  "city",
  "serviceType",
  "fault",
  "faultDetails",
  "assignmentGroup",
  "assigneeId",
  "routeNo",
  "secondaryAssigneeId",
  "createDateTime",
  "closedDateTime",
  "status",
  "customer",
  "vaultAccessRequired",
  "remarks",
  "resolutionNotes",
];
